import Swiper from 'swiper';
import detectMobile from '@/scripts/utils/detect-mobile';
import 'jquery-zoom';

export default function () {
  const check = $('.swiper-wrapper');
  if (!check.length) return;

  $('[data-type*="media-slider"]').each((i, el) => {
    const $slider = $(el).find('[data-type*="media-slider-slides"]');
    const nextBtn = $(el).find('[data-type*="slider-nav-next"]');
    const prevBtn = $(el).find('[data-type*="slider-nav-prev"]');
    const centeredSlider = $(el).data('centered');
    const rowSlider = $(el).data('row');

    if (!$slider.length) return;

    const swiperConfig = {
      loop: false,
      effect: 'slide',
      slidesPerView: 'auto',
      speed: 700,
      slideToClickedSlide: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    };

    if (centeredSlider) {
      swiperConfig.centeredSlides = true;
    }
    if (rowSlider) {
      swiperConfig.slidesPerColumn = rowSlider;
      swiperConfig.breakpoints = {
        640: {
          slidesPerColumn: 1,
          centeredSlides: true,
        },
      };
    }

    new Swiper($slider, swiperConfig);
  });
  $('[data-type*="media-slider-thumb"]').each((i, el) => {
    const $slider = $(el).find('[data-type*="media-slider-thumb-slides"]');
    const $thumbsSlider = $(el).find('[data-type*="media-slider-thumb-lines"]');
    const nextBtn = $(el).find('[data-type*="slider-nav-next"]');
    const prevBtn = $(el).find('[data-type*="slider-nav-prev"]');
    const centeredSlider = $(el).data('centered');
    let slideEffect = $(el).data('slide-effect');
    const imageZoom = $(el).data('image-zoom');
    if (!slideEffect) {
      slideEffect = 'fade';
    }

    if (!$slider.length) return;

    const swiperConfig = {
      loop: false,
      effect: slideEffect,
      speed: 700,
      slidesPerView: 'auto',
      autoHeight: true,
      preloadImages: false,
      allowTouchMove: false,
      lazy: {
        loadPrevNext: true,
      },
    };
    const swiperThumblineConfig = {
      loop: false,
      effect: 'slide',
      slidesPerView: 'auto',
      simulateTouch: false,
      speed: 400,
      spaceBetween: 30,
      breakpoints: {
        640: {
          spaceBetween: 0,
        },
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    };
    if (centeredSlider) {
      swiperConfig.centeredSlides = true;
    }

    const swiper = new Swiper($slider, swiperConfig);
    const swiperThumbline = new Swiper($thumbsSlider, swiperThumblineConfig);
    let selectedIndex = 0;
    const selectedSlideClass = 'selected-slide';
    function setSelectedIndex(index) {
      swiperThumbline.slides[selectedIndex].classList.remove(selectedSlideClass);
      selectedIndex = index;
      swiperThumbline.slides[selectedIndex].classList.add(selectedSlideClass);
      swiper.slideTo(selectedIndex);
    }
    swiperThumbline.slides.each((index, slide) => {
      slide.addEventListener('click', () => {
        setSelectedIndex(index);
      });
    });
    setSelectedIndex(0);

    if (imageZoom) {
      const zoomSlides = $(el).find('[data-role="zoom-image"]');
      zoomSlides.each((l, slide) => {
        $(slide).zoom({
          url: $(slide).data('url'),
          magnify: 1.5,
        });
      });
    }
  });

  $('.media-slider_card').each((i, el) => {
    if (detectMobile()) {
      $(el).addClass('show-slider');
    }
  });
}



// WEBPACK FOOTER //
// ./scripts/blocks/sliders.js